import type { SelfDescribingJson } from '@snowplow/browser-tracker'

export function appViewMessageHandler(handler: string, dataToSend: any, analyticsContexts?: Array<SelfDescribingJson>) {
  if (typeof window.webkit?.messageHandlers?.[handler]?.postMessage === 'function') {
    const message = JSON.stringify(dataToSend)
    window.webkit.messageHandlers[handler].postMessage({
      message,
      analyticsContexts,
    })
  } else if (typeof window.appInterface?.postMessage === 'function') {
    const message = JSON.stringify({
      event: handler,
      dataToSend,
      analyticsContexts,
    })
    window.appInterface.postMessage(message)

    // Backwards compatibility for Android
    // Need to send this message as a string for users who never upgraded to newest versions
    if (handler === 'authenticateUser') {
      window.appInterface.postMessage(dataToSend)
    }
  }
}
